import { render, staticRenderFns } from "./CollapseTasks.vue?vue&type=template&id=1b132476&scoped=true&"
import script from "./CollapseTasks.vue?vue&type=script&lang=js&"
export * from "./CollapseTasks.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTasks.vue?vue&type=style&index=0&id=1b132476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b132476",
  null
  
)

export default component.exports